export const recipts = [ { name: 'Wegański shake matcha',
prev: 'bananen_shake.jpg',
time: '10 min.',
ingredients:
 [ '½ litra mleka migdałowego',
   '1 dojrzały banan',
   '2 daty',
   '1 łyżeczka nasion chia',
   '1,5 łyżeczki proszku matcha',
   ', ½ łyżeczki soku z cytryny' ],
preparation:
 [ 'Obierz banana i wymieszaj z mlekiem migdałowym, datami, nasionami chia i proszkiem matcha w wysokim pojemniku lub puree.',
   'Wlej shake do szklanki. Wymieszaj sok z cytryny w shake\'u i podaj.' ],
portions: 1,
tags: [ 'Wachmacher', 'Snacks', 'Drink', 'Vegan' ] },
{ name: 'Wegańska zupa pomidorowa',
prev: 'vegan_tomaten_suppe.jpg',
time: '30 min.',
ingredients:
 [ '½ cebuli',
   '1 ząbek czosnku',
   '1 papryka chili',
   '2 pomarańcze (nieopryskane)',
   '2 łyżki oliwy z oliwek',
   '2 łyżeczki koncentratu pomidorowego',
   '1 kl. Pomidory obrane cyną (150 g)',
   '200 ml osolonej wody',
   ', Sól, pieprz, zioła' ],
preparation:
 [ 'Obierz cebulę i czosnek, drobno posiekaj. Umyj paprykę chili, pokroić w cienkie pierścienie. Obierz pomarańcze i wyciśnij około 120 ml soku. Połóż skórkę na pół pomarańczy.',
   'Podgrzej oliwę na patelni. Włóż kostki cebuli, czosnek i chili na patelnię, krótko podsmaż. Następnie dodaj koncentrat pomidorowy i krótko smaż. Dodaj sok pomarańczowy i pół pomarańczową skórkę na patelnię. Niech gotuje przez krótki czas.',
   'Odcedź puszkowane pomidory i dodaj do patelni z osoloną wodą. Doprowadzić do wrzenia i gotować na średnim ogniu przez 15-20 minut.',
   'Zabierz Organgenschale z zupy. Puree zupę. Dopraw solą, pieprzem i ziołami.' ],
portions: 2,
tags: [ 'Der Klassiker', 'Lunch', 'Vegan' ] },
{ name: 'Pikantna zupa z kokosa i soczewicy',
prev: 'scharfe_kokos_linsensuppe_vegan.jpg',
time: '25 min.',
ingredients:
 [ '1 sztuka imbiru (wielkość orzecha laskowego)',
   '1 cebula',
   ', 300 ml mleka kokosowego',
   '150 ml wody',
   '100 g czerwonej soczewicy',
   '2 łyżki oliwy z oliwek',
   '1 puszka kawałków pomidorów (200 g)',
   ', ½ cytryny',
   ', Sól, pieprz, proszek chili' ],
preparation:
 [ 'Cebulę i imbir obrać, pokroić w drobne kawałki. Zagotuj wodę w czajniku.',
   'Podgrzej oliwę na wysokiej patelni. Dodaj imbir, cebulę i soczewicę, krótko podsmaż.',
   'Mleko kokosowe, gotowana woda i kawałki pomidorów na patelni. Doprawiamy chili w proszku. Doprowadzić do wrzenia i gotować na wolnym ogniu przez około 10 minut.',
   'Dopraw solą, pieprzem i sokiem z cytryny.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Wegańska zupa marchewkowo-imbirowa',
prev: 'vegane_ingwer_karotten_suppe.jpg',
time: '30 min.',
ingredients:
 [ '1 cebula',
   ', 300 g marchewki',
   '100 ml osolonej wody',
   '1 sztuka imbiru (wielkość orzecha laskowego)',
   ', ¼ pęczek pietruszki',
   '2 łyżki oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Cebulę i imbir obrać, drobno pokroić w kostkę. Umyć marchew, obrać i pokroić na małe kawałki.',
   'Podgrzej oliwę w rondlu. Podsmażyć kawałki cebuli, aż będą szkliste. Następnie dodaj kawałki marchewki i imbiru i krótko podsmaż. Podsmażyć warzywa soloną wodą i gotować przez około 15 - 20 minut na średnim ogniu.',
   'Zupę rozłóż i dopraw solą i pieprzem. Umyć natkę pietruszki, posiekać i posypać zupę.' ],
portions: 2,
tags: [ 'Vitaminbombe', 'Lunch', 'Vegan' ] },
{ name: 'Wegańska zupa kokosowa ze szpinakiem',
prev: 'vegane_kokos_spinat_suppe.jpg',
time: '25 min.',
ingredients:
 [ '200 ml mleka kokosowego',
   '100 g selera',
   '250 ml wody',
   '100 g kopru włoskiego',
   '200 g szpinaku liściowego',
   ', ½ papryki chili',
   '1 marchewka',
   '1 sztuka imbiru (wielkość orzecha laskowego)',
   ', Sól, pieprz' ],
preparation:
 [ 'Wlej wodę i mleko kokosowe do rondla i zagotuj.',
   'Umyć koper włoski i seler, obrać i pokroić w drobne kawałki. Dodaj warzywa do rondla i gotuj na średnim ogniu przez około 10 minut.',
   'Umyć szpinak, drobno posiekać. Umyj marchewkę, obierz i pokrój w cienkie paski. Obierz imbir, drobno posiekaj. Umyj chili, pokrój w cienkie pierścienie.',
   'Dodaj wszystkie składniki do zupy i gotuj na małym ogniu przez 4 minuty. Dopraw solą i pieprzem.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Sałatka z kalafiora z ciecierzycy',
prev: 'kichererbsen_blumenkohlsalat_vegan.jpg',
time: '20 min.',
ingredients:
 [ '1/2 kalafiora',
   '1 puszka ciecierzycy (240 g masy odsączonej)',
   '2 słupki dymki',
   ', ¼ pęczek pietruszki',
   ', 3 łyżki oliwy z oliwek',
   ', ½ cytryny',
   '1 łyżeczka curry',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyj kalafior, podziel na delikatne różyczki i pokrój na małe kawałki. Podgrzej oliwę na patelni. Brązowy kalafior przez około 10 minut na średnim ogniu.',
   'Spuścić ciecierzycy, spłukać wodą. Następnie umieść w misce i dodaj 1 łyżkę oliwy z oliwek. Umyć cebulę, pokroić w cienkie pierścienie. Umyć natkę pietruszki, drobno posiekać. Wymieszaj cebulę i pietruszkę z ciecierzycą.',
   'Wyciśnij cytrynę i włóż sok z cytryny do miski. Dodaj kalafior. Dopraw curry, solą i pieprzem. Pozostawić do ostygnięcia przed podaniem.' ],
portions: 2,
tags: [ 'Gut vorzubereiten', 'Snacks', 'Vegan' ] },
{ name: 'Wegańskie tajskie curry ze słodkimi ziemniakami',
prev: 'veganes_thai_curry_suesskartoffeln.png',
time: '30 min.',
ingredients:
 [ '2 duże słodkie ziemniaki',
   '1 brokuły',
   ', ½ wiązki dymki',
   '1 czerwona papryka',
   '2 marchewki',
   '1 kl. Puszka mleka kokosowego',
   '1 wapno',
   '1 łyżka sosu sojowego',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz, proszek curry' ],
preparation:
 [ 'Umyć ziemniaki, obrać i pokroić na małe kawałki.',
   'Umyj pozostałe warzywa i pokrój na małe kawałki. Wyciśnij wapno.',
   'Podgrzej oliwę na patelni. Dodaj kawałki marchewki, krótko podsmaż. Następnie stopniowo dodawać brokuły, paprykę i cebulę wiosenną. Podsmażyć krótko. Dopraw solą, pieprzem i curry w proszku.',
   'Dodaj sok z limonki, sos sojowy i mleko kokosowe. Dodaj do niego kawałki ziemniaków. Gotuj na małym ogniu, aż słodkie ziemniaki będą gotowe. Podawaj i podawaj.' ],
portions: 2,
tags: [ 'Sättigend', 'Lunch', 'Vegan' ] },
{ name: 'Wegańska patelnia warzywna ze słodkimi ziemniakami',
prev: 'vegane_gemuesepfannesuesskartoffeln.jpg',
time: '30 min.',
ingredients:
 [ '1 duży słodki ziemniak',
   '1 cebula',
   ', 3 marchewki',
   '1 łyżka oliwy z oliwek',
   '1 brokuły',
   ', 300 ml solonej wody',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyć cebulę i marchewkę, obrać i pokroić w cienką kostkę. Umyć brokuły, pokroić łodygę, obrać, pokroić w drobną kostkę. Odetnij różyczki brokułów. Umyć słodkie ziemniaki, skórkę i kostkę.',
   'Podgrzej oliwę na patelni. Dodaj kostkę cebuli i marchwi na patelnię i podsmaż.',
   'Dodaj kostki ziemniaczane, krótko smaż. Następnie dodaj osoloną wodę. Dodaj kawałki brokułów.',
   'Zamknij patelnię z pokrywką i gotuj przez około 15 minut na średnim ogniu.' ],
portions: 2,
tags: [ 'Ballaststoffreich', 'Lunch', 'Vegan' ] },
{ name: 'Wegańskie curry z tofu',
prev: 'veganes_tofu_curry.jpg',
time: '25 min.',
ingredients:
 [ '300 g tofu',
   '1 mały kawałek imbiru (1 cm)',
   '1 pęczek dymki',
   '2 marchewki',
   '1 żółta papryka',
   ', 30 g orzechów nerkowca',
   '100 ml osolonej wody',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz, proszek curry' ],
preparation:
 [ 'Obierz imbir i zmiel go. Umyć marchew, paprykę i dymkę, pokroić w małe kawałki. Z grubsza siekaj orzechy nerkowca. Kości tofu.',
   'Podgrzej oliwę na patelni. Dodaj kawałki imbiru, marchwi i pieprzu do patelni i krótko podsmaż.',
   'Dodaj kostki tofu. Dopraw wszystkie składniki solą, pieprzem i curry w proszku. Kontynuuj pieczenie przez 2 minuty.',
   'Dodaj 100 ml osolonej wody na patelnię. Pozwól mu się wygotować. Dopraw solą, pieprzem i curry.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Chili sin Carne',
prev: 'chili_sin_carne.jpg',
time: '30 min.',
ingredients:
 [ '300 g tofu',
   '1 cebula',
   '1 ząbek czosnku',
   '1 czerwona papryka',
   '1 czerwona ostra papryka',
   '250 ml przepuszczonych pomidorów',
   '1 mała puszka ziaren kukurydzy',
   '1 mała puszka fasoli',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz, proszek chili' ],
preparation:
 [ 'Kości tofu. Wymieszaj 1 łyżkę oliwy z oliwek z odrobiną chilli i wrzuć do niej kostki tofu.',
   'Cebulę i kostkę czosnku obrać i drobno posiekać. Umyj paprykę i paprykę chili, uformuj je, pokrój na drobne kawałki.',
   'Podgrzej oliwę na patelni. Podsmażyć kostki tofu, doprawić solą i pieprzem, następnie ponownie wyjąć i ogrzać. Dodać cebulę, czosnek i pieprz do patelni, krótko podsmażyć. Dodaj pomidory, dopraw solą i pieprzem. Gotować na średnim ogniu przez 5 minut.',
   'Wypłucz kukurydzę i fasolę i dodaj. Gotuj na średnim ogniu. Złożyć kostki tofu. Dopraw solą, pieprzem i chili w proszku.' ],
portions: 2,
tags: [ 'Fleischlose Alternative', 'Lunch', 'Vegan' ] },
{ name: 'Wegańska kurka',
prev: 'vegane_pfifferlingspfanne.jpg',
time: '30 min.',
ingredients:
 [ '300 g świeżych kurków',
   '1 cebula',
   '1 pęczek szczypiorku',
   '2 łyżki oliwy z oliwek',
   '150 ml śmietany sojowej',
   '1 łyżka musztardy',
   ', Sól, pieprz' ],
preparation:
 [ 'Mycie kurków. Cebulę obrać i pokroić w drobną kostkę. Umyć szczypiorek i pokroić w drobny pierścionek.',
   'Podgrzej oliwę na patelni. Dodaj kurki i krótko podsmaż. Dodaj kawałki cebuli i krótko smaż. Dopraw solą i pieprzem.',
   'Dodaj śmietanę sojową i krótko gotuj.',
   'Dodaj sos do musztardy, dopraw solą i pieprzem. Dodaj szczypiorek i wymieszaj.' ],
portions: 2,
tags: [ 'Ballaststoffreich', 'Lunch', 'Vegan' ] },
{ name: 'Wegańska komora ryżowo-warzywna',
prev: 'vegane_quinoa_gemuese_pfanne.jpg',
time: '30 min.',
ingredients:
 [ '250 g brokułów',
   '1 czerwona papryka',
   '1 ząbek czosnku',
   '1 marchewka',
   '2 łyżki oliwy z oliwek',
   ', 75 g grochu (z zamrażarki)',
   '200 ml osolonej wody',
   '100 g komosy ryżowej',
   ', Sól, pieprz, proszek curry' ],
preparation:
 [ 'Umyć brokuły, pokroić łodygę, obrać i pokroić w różyczki. Potem też pokrój róże.',
   'Umyj papryki, usuń nasiona i pokrój w drobną kostkę. Umyj marchewkę, obierz ją na cienkie plasterki. Obierz czosnek, drobno posiekaj.',
   'Przepłukać quinoa na sicie wodą. Zagotuj około 400 ml wody. Dodaj quinoa. Gotować przez 12 minut. Usuń z ognia, sól i pozostaw do namoczenia przez kolejne 10 minut.',
   'Podgrzej oliwę na patelni. Dodaj paprykę, brokuły, marchewkę i czosnek na patelnię i smaż przez 5 minut na średnim ogniu. Dodaj groszek. Dopraw curry, solą i pieprzem.',
   'Dodaj osoloną wodę. Gotować. Dodaj quinoa i gotuj przez 5 minut.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch', 'Vegan' ] },
{ name: 'Fasola ze śmietaną sojową',
prev: 'bohnen_soja.jpg',
time: '30 min.',
ingredients:
 [ '200 g zielonych, grubych ziaren',
   '1 cebula',
   '1 łyżka oliwy z oliwek',
   '150 g groszku (cyny)',
   '2 szt. Selera',
   '1 łyżka soku z cytryny',
   '100 ml śmietany sojowej',
   ', Sól, pieprz, zioła' ],
preparation:
 [ 'Umyj fasolę. (W zależności od smaku skórkę można usunąć przez krótkie umieszczenie ziaren we wrzącej wodzie i usunięcie skórki). Opróżnij groszek.',
   'Umyć seler, obrać i pokroić w drobną kostkę. Cebulę obrać, drobno posiekać.',
   'Podgrzej oliwę na patelni. Dodaj seler i cebulę, krótko podsmaż. Dodaj fasolę i groszek, dalej gotuj przez około 1 minutę.',
   'Dodaj sok z cytryny i pozwól mu się wygotować. Dodaj krem sojowy. Doprowadzić do wrzenia. Gotować na średnim ogniu przez 5 minut.',
   'Ułóż z ziołami i podawaj według życzenia.' ],
portions: 2,
tags: [ 'Leicht', 'Lunch', 'Vegan' ] },
{ name: 'Wegańska tofu na patelni',
prev: 'vegane_tofu_gemuese_pfanne.jpg',
time: '35 min.',
ingredients:
 [ '1 kij pora',
   ', 80 g amarantusa',
   '200 g tofu',
   '1 pieprz',
   ', 350 g marchewki',
   '1 łyżka oliwy z oliwek',
   '150 ml wody',
   ', ½ kiści pietruszki',
   ', ½ cytryny',
   ', Sól, pieprz' ],
preparation:
 [ 'Zanurz wodę w rondlu. Dodaj amarant i zagotuj. Pozwól amarantowi pęcznieć przez około 20 minut na małym ogniu.',
   'Obierz marchewki, pokroić w plasterki. Umyj pora i pokrój w pierścienie. Umyj cytrynę i przetrzyj skórę. Wytnij tofu w paski. Umyć pietruszkę, mieloną. Umyj papryki, usuń nasiona, pokrój na małe kawałki.',
   'Podgrzej oliwę na patelni. Podsmaż tofu na krótki czas. Dodaj pora, krótko podsmaż. Następnie dodaj marchewki, również krótko gotuj na parze. Dodaj amarantus z odrobiną wody i gotuj przez 5 minut.',
   'Dodaj pietruszkę. Dopraw solą, pieprzem i skórką z cytryny.' ],
portions: 2,
tags: [ 'Mit Amaranth', 'Lunch', 'Vegan' ] },
{ name: 'Wegański gulasz curry',
prev: 'veganer_curry_eintopf.jpg',
time: '35 min.',
ingredients:
 [ '½ pora',
   '1 duży słodki ziemniak',
   '2 łyżki oliwy z oliwek',
   '100 g soczewek',
   '1TL pasta pomidorowa',
   '200 ml wody',
   ', Sól, pieprz, proszek curry' ],
preparation:
 [ 'Umyj por, pokrój w pierścienie. Umyć słodkie ziemniaki, obrać, pokroić w kostkę.',
   'Podgrzej oliwę na patelni. Podsmażyć por, słodkie ziemniaki i soczewicę. Dodaj przecier pomidorowy, dopraw curry i zalej wodą. Dopraw solą i pieprzem. Gotuj od czasu do czasu mieszając przez około 15 minut.',
   'Dopraw solą, pieprzem i curry. Ułóż z ziołami i podawaj zgodnie z życzeniem.' ],
portions: 2,
tags: [ 'Sättigend', 'Lunch', 'Vegan' ] },
{ name: 'Marchewkowe curry z moreli',
prev: 'karotten_aprikosen_curry.jpg',
time: '30 min.',
ingredients:
 [ '200 g tofu',
   '1 duża cebula',
   ', 300 g marchewki',
   '100 g moreli (cyna)',
   '1 ząbek czosnku',
   '100 ml mleka kokosowego',
   ', 75 ml wody',
   '1 łyżka oliwy z oliwek',
   '1 papryka chili',
   ', Sól, pieprz, proszek curry' ],
preparation:
 [ 'Wytnij tofu w paski. Przetnij morele na cienkie kostki i trzymaj sok z puszki. Obierz cebulę, marchew i czosnek pokrojoną w cienką kostkę. Umyj paprykę chili, pokroić w cienkie pierścienie.',
   'Podgrzej oliwę na patelni. Smażyć paski tofu ze wszystkich stron na średnim ogniu. Dopraw solą i pieprzem, zdejmij i rozgrzej.',
   'Włóż czosnek i cebulę do patelni i krótko podsmaż. Następnie dodaj kawałki marchwi, również krótko podsmaż. Dopraw curry i zalej wodą.',
   'Dodaj kawałki moreli i sok, pierścienie chilli, mleko kokosowe. Dopraw solą i pieprzem. Dodaj tofu i pozwól mu stromić przez 10 minut.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Chili con carne',
prev: 'chili_con_carne.jpg',
time: '25 min.',
ingredients:
 [ '300 g mielonej wołowiny',
   '1 papryka chili',
   '1 cebula',
   ', ½ ząbka czosnku',
   '1 duża puszka pomidorów',
   '1 łyżeczka chilli w proszku',
   '1 puszka fasoli nerkowej (250 g)',
   '2 łyżki oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Ząbek czosnku obrać i cebulę pokroić w drobną kostkę. Podgrzej oliwę na patelni. Cebulę i czosnek pocić przez 5 minut.',
   'Umyj i posiekaj papryczkę chili. Dodaj do patelni z proszkiem chili. Braise przez około 2 minuty.',
   'Dodaj mięso mielone i sauté. Wymieszaj pomidory i fasolę nerkową. Dopraw solą i pieprzem.',
   'Gotuj na wolnym ogniu przez około 90 minut.' ],
portions: 2,
tags: [ 'Gut vorzubereiten', 'Lunch' ] },
{ name: 'Patelnia z papryką wołową',
prev: 'rindfleisch_paprika.png',
time: '20 min.',
ingredients:
 [ '2 kawałki mięsa ze steków',
   '1 cebula',
   '1 pieprz',
   '1 ostra papryka',
   '2 łyżki oliwy z oliwek',
   ', W razie potrzeby: 1 łyżka sosu sojowego',
   ', Sól i pieprz' ],
preparation:
 [ 'Umyj paprykę i ostrą paprykę, usuń nasiona i pokrój w paski. Obierz cebulę, pokroić w pierścienie. Pokrój mięso w paski.',
   'Podgrzej oliwę na patelni. Smażyć paski mięsa i dopraw solą i pieprzem. Dodaj paprykę, cebulę i pieprz i krótko podsmaż.',
   'Schłodzić i podawać z sosem sojowym zgodnie z potrzebami.' ],
portions: 2,
tags: [ 'Deftig', 'Lunch' ] },
{ name: 'Süßkartoffelspalten',
prev: 'suesskartoffelspalten.jpg',
time: '30 min.',
ingredients:
 [ '3-4 słodkie ziemniaki',
   ', 3 ząbki czosnku',
   ', Sól, pieprz, ewentualnie papryka w proszku',
   ', 3 łyżki oliwy z oliwek',
   ', 3 łyżki chudego twarogu' ],
preparation:
 [ 'Umyć ziemniaki i pokroić w plasterki o jednakowej wielkości. Rozłóż równomiernie na blasze wyłożonej papierem do pieczenia.',
   'Rozgrzej piekarnik do 200 stopni. Obierz ząbki czosnku i posiekaj je na drobne kawałki. Wymieszaj z oliwą i dopraw solą, pieprzem i papryką.',
   'Rozłóż równomiernie mieszankę czosnku i przypraw na klinach ziemniaczanych. Piec w piekarniku przez 15-20 minut.',
   'Ułóż kliny ziemniaczane z kwarkiem ziołowym i podawaj.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch', 'Snacks' ] },
{ name: 'Karmazyn na kurkach',
prev: 'rotbarsch_auf_pfifferlingen.jpg',
time: '30 min.',
ingredients:
 [ '2 połówki karmazyna (300 g)',
   ', ½ cebuli',
   '150 g kurków (świeżych lub mrożonych)',
   ', ½ wiązki dymki',
   '200 g małych pomidorów',
   '2 łyżki oliwy z oliwek',
   '1 łyżka soku z cytryny',
   ', Sól i pieprz' ],
preparation:
 [ 'Umyj ryby i usuń wszystkie kości.',
   'Skropić filety sokiem z cytryny i doprawić solą.',
   'Obierz cebulę, posiekaj ją na drobne kawałki. Cebulę umyć, pokroić w cienkie pierścienie. Mycie kurków.',
   'Umyj pomidory. Włóż gorącą wodę z czajnika do miski. Pokrój małe pomidory w pomidory i dodaj do gorącej wody. Zdejmij po kilku minutach i odklej skórę.',
   'Wlej oliwę na patelnię i podgrzej. Dodaj kawałki cebuli i smaż, aż będą szkliste. Następnie dodaj kurki i podsmaż na około 8 minut.',
   'Dodaj cebulkę i pomidory do kurków. Pozwól mu odpocząć przez około 3 minuty. Następnie dopraw solą i pieprzem.',
   'Na osobnej patelni usmaż filety rybne w & nbsp; oliwie z obu stron przez 3 minuty.' ],
portions: 2,
tags: [ 'Proteinreich', 'Lunch' ] },
{ name: 'Omlet z chili con carne',
prev: 'chili_con_carne_omelette.jpg',
time: '30 min.',
ingredients:
 [ '4 jajka',
   '1 cebula',
   '1 ząbek czosnku',
   '2 łyżki oliwy z oliwek',
   '1 czerwona papryka',
   '1 duża puszka pomidorów',
   '250 g mielonej wołowiny',
   '1 papryka chili',
   '1 łyżeczka chilli w proszku',
   '1 puszka fasoli nerkowej (250 g)',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyj papryki i pokrój je w kostkę. Obierz cebulę i ząbek czosnku i posiekaj je na drobne kawałki. Paprykę chili umyć i pokroić w drobny pierścionek.',
   'Podgrzej oliwę na patelni i smaż mięso mielone. Dodaj kawałki chili, cebuli, czosnku i pieprzu i smaż przez 2 minuty.',
   'Dodaj pomidory i fasolę nerkową z puszki. Dopraw solą, pieprzem i chili w proszku. Mieszaj i gotuj przez kilka minut.',
   'W międzyczasie podgrzej oliwę z oliwek w drugiej patelni. Dodaj 2 ubite jajka do omletu na małym ogniu. Surowe jaja dopraw solą i pieprzem według potrzeby. Delikatnie obróć omlet i wyjmij z patelni. Zrób drugi omlet w ten sam sposób.',
   'Rozłóż gotowe chili na omletach i złóż.' ],
portions: 2,
tags: [ 'Low Carb', 'Breakfast', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Faszerowane papryki kuskusowe z fetą',
prev: 'couscous_paprika_mit_feta.jpg',
time: '30 min.',
ingredients:
 [ '2 papryki',
   '100 g surowego kuskusu',
   '1 łyżka oliwy z oliwek',
   '100 g sera feta',
   ', 50 g oliwek (pestki)',
   ', 3 pomidory koktajlowe',
   ', Sól, pieprz, bazylia' ],
preparation:
 [ 'Pokroić paprykę na pół, wzmocnić je i umyć.',
   'Zagotuj osoloną wodę w rondlu. Wyjąć z ognia i dodać kuskus z mieszaniem. Przykryj pokrywką i pozwól pęcznieć na małym ogniu przez 5 minut.',
   'Pokrój ser feta. Umyj oliwki i pokrój na drobne kawałki. Umyj pomidory, pokrój w drobne kawałki. Wymieszać ser, oliwki i pomidory z kuskusem. Dopraw solą, pieprzem i bazylią.',
   'Rozgrzej piekarnik do 200 stopni Celsjusza. Napełnij paprykę mieszanką kuskus-feta. Włóż do piekarnika i piecz przez 20 minut' ],
portions: 2,
tags: [ 'Gut vorzubereiten', 'Lunch' ] },
{ name: 'Kasseler w sosie z musztardy jabłkowej',
prev: 'kasseler_apfel.jpg',
time: '30 min.',
ingredients:
 [ '2 kotlety boczne bez kości',
   '2 jabłka',
   '100 ml bulionu warzywnego',
   '2 łyżki soku z cytryny',
   '2 łyżki musztardy',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyć jabłka, obrać i pokroić w drobną kostkę. Następnie posypać sokiem z cytryny.',
   'Podgrzej patelnię z oliwą z oliwek i piecz przez około 3 minuty z każdej strony. Dodaj kostkę jabłka i smaż przez kolejne 7 minut przy małym ogniu. Dopraw solą i pieprzem.',
   'Usuń plastry Kasseler z patelni i ogrzej. Kostkę jabłkową obtoczyć bulionem warzywnym. Wymieszać musztardę i, jeśli to konieczne, doprawić ponownie solą i pieprzem. Połóż Kasselera na patelni i pozwól mu odpocząć przez 10 minut.',
   'Służ i ciesz się!' ],
portions: 2,
tags: [ 'Deftig', 'Lunch' ] },
{ name: 'Łosoś na kapuście włoskiej',
prev: 'lachs_bohnen.jpg',
time: '30 min.',
ingredients:
 [ '350 g kapusty włoskiej',
   ', 4 łyżki śmietany niskotłuszczowej',
   ', 300 g filetu z łososia bez skóry',
   '2 łyżeczki oliwy z oliwek',
   '1 plasterki cytryny',
   ', 50 ml mleka niskotłuszczowego',
   '1 łyżeczka koperku',
   ', Curry w proszku, gałka muszkatołowa, sól, pieprz' ],
preparation:
 [ 'Umyj kapustę włoską i pokrój w paski. Doprowadź soloną wodę do wrzenia. Dodaj kapustę savoy i gotuj, aż paski będą miękkie.',
   'Umieść krem i mleko w innym garnku i podgrzej. Doprowadzić do wrzenia, aż połowa wyparuje. Dodaj kapustę włoską i dopraw do smaku curry, gałką muszkatołową, solą i pieprzem.',
   'Podgrzej oliwę na patelni. Piecz filety z łososia na średnim ogniu przez około 3 minuty. Dopraw solą i pieprzem.',
   'Podawaj wszystko na talerzu i przykryj łososiem plasterkami cytryny, posyp koperkiem.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch' ] },
{ name: 'Kolorowe warzywa piekarnik',
prev: 'buntes_ofengemuese.jpg',
time: '35 min.',
ingredients:
 [ '1 cukinia',
   '1 czerwona papryka',
   '1 żółta papryka',
   ', 300 g grzybów',
   ', 4 pomidory',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz, zioła, np. Zioła Prowansji' ],
preparation:
 [ 'Rozgrzej piekarnik do 200 stopni Celsjusza.',
   'Umyj warzywa i pokrój. Jedz pomidory.',
   'Połóż blachę do pieczenia papierem do pieczenia i posmaruj olejem. Umieść warzywa na blasze do pieczenia. Dopraw do smaku solą, pieprzem i ziołami.',
   'Piec przez 20 minut.' ],
portions: 2,
tags: [ 'Leicht', 'Lunch', 'Vegan' ] },
{ name: 'Gulasz z fasoli curry',
prev: 'burry_bohnen_eintopf.jpg',
time: '35 min.',
ingredients:
 [ '1 cukinia',
   '1 cebula',
   '1 pieprz',
   ', 500 ml wody',
   '1 puszka białej fasoli',
   '1 pęczek warzyw zupy: 2 marchewki, ½ pałeczki pora, 1 kawałek selera',
   ', W razie potrzeby: 2 kawałki kiełbasy parówki (mięso z indyka o niskiej zawartości tłuszczu)',
   ', Sól, pieprz, curry' ],
preparation:
 [ 'Umyć warzywa małe. Podgrzej oliwę w rondlu. Dodaj warzywa i krótko podsmaż. Dopraw solą, pieprzem i curry. Dodaj wodę i gotuj na wolnym ogniu przez około 20 minut.',
   'Umyj fasolę wodą, a następnie włóż do garnka. Gotuj przez około 10 minut.',
   'Podawaj i podawaj. Jeśli chcesz, możesz pokroić kawałki kiełbasy z indyka o niskiej zawartości tłuszczu.' ],
portions: 2,
tags: [ 'Deftig', 'Lunch' ] },
{ name: 'patelni krewetki',
prev: 'garnelenpfanne.jpg',
time: '20 min.',
ingredients:
 [ '400 g krewetek (świeże lub mrożone)',
   '250 g pomidorów cherry',
   '250 g grzybów',
   '1 cytryna',
   '1 łyżeczka musztardy',
   ', 4 dymki',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz, pietruszka' ],
preparation:
 [ 'Rozmrozić mrożone krewetki przed przygotowaniem.',
   'Podgrzej oliwę na patelni. Podsmażyć na krótko krewetki i rozjaśnić sokiem z cytryny.',
   'Umyj grzyby, pomidory i szczypiorki. Połówki grzybów i pomidorów. Pokroić cebulę wiosenną w pierścienie. Umieść grzyby na patelni i krótko podsmaż.',
   'Dodaj pomidory i wiosenną cebulę do patelni. Braise krótko.',
   'Dopraw solą, pieprzem i musztardą. Podawać i posypać natką pietruszki.' ],
portions: 2,
tags: [ 'Leicht', 'Lunch' ] },
{ name: 'Łosoś ziołowy z fasolą',
prev: 'krrauter_lachs_mit_bohnen.jpg',
time: '30 min.',
ingredients:
 [ '2 steki z łososia bez skóry',
   ', 40 g oliwek',
   '200 g zielonej fasoli',
   '1 łyżka niskotłuszczowego sera śmietankowego',
   '2 łyżeczki masła ziołowego',
   ', 4 pomidory koktajlowe',
   ', Sól, pieprz' ],
preparation:
 [ 'Doprawić steki z łososia solą i pieprzem. Umyj oliwki i pokrój w cienkie pierścienie. Wymieszać oliwki z masłem ziołowym i serem śmietankowym. Dopraw solą i pieprzem.',
   'Umyj fasolę i gotuj na średnim ogniu w osolonej wodzie.',
   'Pomyj pomidory, przeciąć na pół. Umieść ze stekami z łososia w patelni grillowej i smaż ryby przez około 3-4 minuty z obu stron.',
   'Podawać steki z łososia na talerzach. Roztop śmietanę z kremowego sera z masłem ziołowym na ryby & nbsp; Dodaj fasolę i podawaj.' ],
portions: 1,
tags: [ 'Proteinreich', 'Lunch' ] },
{ name: 'Falafelpizza',
prev: 'falafelpizza.jpg',
time: '30 min.',
ingredients:
 [ '1 jajko',
   '1 cebula',
   '1 paczka mieszanki falafel',
   ', 3 pomidory',
   '2 plasterki szynki',
   '1 pieprz',
   '100 g grzybów' ],
preparation:
 [ 'Obierz cebulę i posiekaj ją na drobne kawałki. Pomidory i grzyby umyć, pokroić na małe kawałki. Umyj papryki, usuń nasiona i pokrój w cienkie paski. Plastry szynki pokroić na małe kawałki.',
   'Rozgrzej piekarnik do 200 stopni Celsjusza.',
   'Przygotuj mieszankę falafel zgodnie z instrukcjami na opakowaniu. Niech puchnie krótko.',
   'Przygotowaną mieszankę falafel wymieszać z kostkami cebuli i jajkiem. Następnie rozłóż na blasze wyłożonej papierem do pieczenia i piecz około 5 minut.',
   'Zdejmij z piekarnika podstawę z falafelem i udekoruj szynką i warzywami. Jeśli to konieczne, posypać parmezanem. Włóż z powrotem do piekarnika i piecz przez kolejne 10 minut.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch', 'Snacks' ] },
{ name: 'Putenwraps',
prev: 'putengeschnetzeltes_mit_tomaten.jpg',
time: '30 min.',
ingredients:
 [ '4 jajka',
   '2 łyżki zmielonych migdałów',
   '1 łyżka oliwy z oliwek',
   '200 g plasterków indyka',
   ', 4 pomidory koktajlowe',
   '1 pieprz',
   '2 łyżeczki musztardy',
   ', Sól, pieprz' ],
preparation:
 [ 'Rozgrzej oliwę na patelni.',
   'Dobrze wymieszaj jajka i zmielone migdały. Dopraw do smaku solą i pieprzem.',
   'Dodaj połowę płynu do patelni. Rozłóż, przesuwając w panoramie. Zwiększ ponad średnie ciepło. Powtórz proces dla drugiego dna zawijania.',
   'Pomyj pomidory i pokrój na małe kawałki. Umyj papryki, usuń nasiona i pokrój na małe kawałki.',
   'Podgrzej oliwę w innej patelni. Włóż indyka i krótko podsmaż. Dopraw solą i pieprzem.',
   'Pokryć oba dno do zawijania musztardą. Przykryj indykiem i warzywami. Zwiń i ciesz się.' ],
portions: 1,
tags: [ 'Proteinreich', 'Lunch', 'Snacks' ] },
{ name: 'Curry Coconut Lentil Pot',
prev: 'kokos_linsen.jpg',
time: '20 min.',
ingredients:
 [ '1 duże dawki soczewicy',
   ', ½ wiązki dymki',
   '2 łyżki proszku curry',
   '1 łyżeczka pieprzu cayenne',
   '1 łyżeczka kminku',
   ', ½ puszki mleka kokosowego',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Podgrzej oliwę na patelni.',
   'Umyć dymkę i pokroić w pierścienie. Dodaj do patelni i krótko podsmaż. Dodaj mleko kokosowe i soczewicę. Dopraw przyprawy do smaku. Gotować przez 15-20 minut.' ],
portions: 1,
tags: [ 'Exotisch', 'Lunch', 'Vegan' ] },
{ name: 'Warzywo z łososiem',
prev: 'lachsfilet_auf_gemuese.jpg',
time: '30 min.',
ingredients:
 [ '1 cukinia',
   '150 g łososia (bez skóry)',
   '1 marchewka',
   '1 brokuły',
   '1 cebula',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyj warzywa i pokrój na małe kawałki. Obrać marchewkę i cebulę, pokroić w drobne kawałki. Rozgrzej oliwę na patelni.',
   'Dodaj łososia na patelnię i smaż na obu stronach na średnim ogniu. Po 3 minutach dodaj warzywa do patelni i podsmaż. Od czasu do czasu płonąć wodą.',
   'Dopraw solą i pieprzem.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch' ] },
{ name: 'Patelnia kokosowa z indyków',
prev: 'puten_kokos_pfanne.jpg',
time: '20 min.',
ingredients:
 [ '400 g plasterków indyka',
   '1 puszka grzybów',
   '1 cebula wiosenna',
   '1 mała puszka zielonej fasoli',
   '250 ml przepuszczonych pomidorów',
   '20 ml mleka kokosowego',
   '2 łyżki pesto pomidorowego',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyj szczypiorki i pokrój w cienkie pierścienie. Opróżnij grzyby i fasolę. Podgrzej oliwę na patelni.',
   'Pokrój indyka i usmaż krążki cebuli na średnim ogniu. Przekazane pomidory, mleko kokosowe i pesto.',
   'Dodaj grzyby i fasolę. Dopraw solą i pieprzem. Gotuj przez około 10 minut na średnim ogniu.' ],
portions: 2,
tags: [ 'Superschnell', 'Lunch' ] },
{ name: 'Turcja krojona w sosie orzechowym',
prev: 'putengeschnetzeltes_mit_curry_kokosmilch.jpg',
time: '30 min.',
ingredients:
 [ '400 kawałków indyka',
   '200 ml mleka kokosowego',
   '250 ml bulionu warzywnego',
   ', 4 łyżki masła orzechowego (niesłodzone)',
   '2 marchewki',
   '1 ząbek czosnku',
   '1 papryka chili',
   '1 cebula wiosenna',
   '200 g brokułów',
   ', ½ cytryny',
   '2 łyżki oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Brokuły i cebulę umyć, pokroić w plasterki. Umyj marchewkę, skórkę i pokrój. Wyciśnij sok z cytryny. Podgrzej oliwę na patelni.',
   'Umieść warzywa i plastry indyka na patelni, krótko podsmaż. Dodaj 150 ml wody do rondla. Gotować przez kilka minut, aż woda wyparuje.',
   'Umyj paprykę chili, pokroić w cienkie pierścienie. Obierz ząbek czosnku, posiekaj go na drobne kawałki. Podgrzej oliwę w rondlu. Na patelni krótko smaż plasterki chili i kawałki czosnku. Dodaj mleko kokosowe i zagotuj.',
   'Usuń garnek z ognia. Dodaj masło orzechowe i sok z cytryny. Dopraw solą i pieprzem.',
   'Podawać warzywa i plastry indyka z sosem orzechowym.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch' ] },
{ name: 'Polędwica wołowa na warzywach paprykowych',
prev: 'rinderfilet_auf_paprikagemuse.jpg',
time: '30 min.',
ingredients:
 [ '2 filety wołowe',
   ', 3 papryki (czerwona, żółta)',
   '1 cebula',
   '150 g grzybów',
   '1 ząbek czosnku',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz, papryka w proszku' ],
preparation:
 [ 'Podgrzej oliwę na patelni. Obierz ząbek czosnku, drobno posiekaj. Umyj papryki, usuń nasiona, pokrój w paski. Obierz cebulę, posiekaj ją na drobne kawałki. Umyj grzyby, drobno posiekaj.',
   'Dopraw filety wołowe solą i pieprzem. Krótko usmaż kawałki czosnku na patelni. Dodaj filety wołowe i smaż przez około 7 minut z każdej strony. Wyjmij i rozgrzej.',
   'Umieść paprykę, grzyby i cebulę na patelni i smaż przez 5 minut. Dopraw solą i pieprzem.',
   'Podawać pieczone warzywa z filetami wołowymi.' ],
portions: 2,
tags: [ 'Für Feinschmecker', 'Lunch' ] },
{ name: 'Bratkohlrabi',
prev: 'bratkohlrabi.jpg',
time: '30 min.',
ingredients:
 [ '1 cebula',
   '1 kalarepa',
   '2 kromki gotowanej szynki',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Kalarepę obrać i pokroić w cienkie plasterki. Cebulę obrać i pokroić w cienkie plasterki.',
   'Podgrzej oliwę na patelni. Połóż plasterki kalarepy na patelni i smaż na średnim ogniu, aż będą miękkie. W międzyczasie pokrój szynkę w paski.',
   'Dodaj krążki cebuli i paski szynki do plasterków kalarepy i dopraw solą i pieprzem.' ],
portions: 2,
tags: [ 'Low Carb', 'Lunch', 'Snacks' ] },
{ name: 'Pikantna sałatka z ciecierzycy',
prev: 'scharfer_kichererbsensalat.jpg',
time: '10 min.',
ingredients:
 [ '300 g gotowanej ciecierzycy',
   '1 cebula',
   ', 4 pomidory koktajlowe',
   '1 pieprz (czerwony / żółty)',
   '1 ząbek czosnku',
   '1 łyżka pasty pomidorowej',
   '1 łyżka oliwy z oliwek',
   '1 łyżka sosu sojowego',
   '1 łyżka ziół (na przykład pietruszka)',
   ', Sól, pieprz, papryka w proszku' ],
preparation:
 [ 'Obierz czosnek i cebulę, drobno posiekaj. Następnie wymieszaj z pastą pomidorową, oliwą z oliwek, sosem sojowym. Doprawić papryką w proszku.',
   'Umyj paprykę i pomidory, pokrój na małe kawałki. Wymieszać z ciecierzycą i dodać sos. Na koniec wymieszaj zioła. Dopraw solą i pieprzem.' ],
portions: 2,
tags: [ 'Exotisch', 'Lunch', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Bagietka z łososia ogórkowego',
prev: 'gurken_lachs.jpg',
time: '10 min.',
ingredients:
 [ '1 duży ogórek',
   '250 g łososia',
   ', 8 łyżek twarogu',
   '2 łyżki pietruszki (świeże lub suszone)',
   '1 ząbek czosnku',
   ', ½ cytryny',
   '2 łyżki grochu z puszki',
   ', Sól, pieprz' ],
preparation:
 [ 'Obierz czosnek, drobno posiekaj.',
   'Umyć ogórek, obrać, przeciąć na pół. Ostrożnie wyciąć wnętrze ogórka nożem i posiekać na drobne kawałki.',
   'Wyciśnij cytrynę. Wymieszaj sok z cytryny z kawałkami twarogu, czosnku, groszku, pietruszki i ogórka.',
   'Rozłóż połówki ogórka kremem i przykryj wędzonym łososiem.' ],
portions: 2,
tags: [ 'Leicht', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Przekąska z serem tuńczykowym',
prev: 'thunfisch_huettenkaese.png',
time: '5 min.',
ingredients:
 [ '250 g twarogu',
   '1 puszka tuńczyka (bez oleju)',
   '150 g twarogu',
   '1 cebula wiosenna',
   ', Sól, pieprz' ],
preparation:
 [ 'Cebulę umyć, pokroić w cienkie pierścienie. Opróżnij tuńczyka.',
   'W misce wymieszaj tuńczyka, twarożek i dymkę.',
   'Dopraw solą i pieprzem.' ],
portions: 1,
tags: [ 'Superschnell', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Pałeczki warzywne z dipem',
prev: 'gemuesesticks.png',
time: '10 min.',
ingredients:
 [ '1 pieprz',
   ', ½ ogórka',
   '2 marchewki',
   ', ½ wiązki rzodkiewek',
   ', ½ cukinii',
   '250 g niskotłuszczowego twarogu',
   ', Pół szczypiorku',
   ', ½ papryczki chilli (ewentualnie chilli w proszku)',
   ', Sól, pieprz, sok z cytryny' ],
preparation:
 [ 'Umyć warzywa, obrać i pokroić w cienkie paski.',
   'Umyć szczypiorek i paprykę chili, pokroić w drobny pierścionek.',
   'Trzcina z szczypiorkiem i papryką chili. Dopraw solą i pieprzem. Dodaj odrobinę soku z cytryny, jak chcesz. Podawaj dip w małej miseczce z pałeczkami warzywnymi.' ],
portions: 1,
tags: [ 'Leicht', 'Dinner', 'Snacks' ] },
{ name: 'Przekąska z awokado Champignon',
prev: 'champignon_avocado_snack.jpg',
time: '25 min.',
ingredients:
 [ '1 awokado',
   '100 g grzybów',
   ', ½ sałaty lodowej',
   '1 marchewka',
   '1 pomidor',
   '1 garść ziaren nerkowca',
   '2 łyżki oliwy z oliwek',
   ', 4 łyżki niskotłuszczowego twarogu',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyć sałatę lodową, pokroić i umieścić w misce. Marchewkę, umyj pomidor i pokrój na małe kawałki. Dodaj do miski.',
   'Przekrój awokado na pół, wyjmij rdzeń i usuń awokado łyżką. Przetwarzaj mięso z awokado z połówki na miąższ widelcem i pokrój drugą połówkę na małe kawałki.',
   'Podgrzej oliwę na patelni. Umyj grzyby, pokrój. Dodaj do patelni i krótko podsmaż. Dodaj grzyby do pozostałej sałatki.',
   'Wymieszaj owsiankę z awokado z chudym twarogiem. Drobno posiekaj orzechy nerkowca i dodaj do mieszanki awokado i twarogu. Dopraw solą i pieprzem. Nadaj sałatce sos.' ],
portions: 1,
tags: [ 'Gut vorzubereiten', 'Dinner', 'Snacks' ] },
{ name: 'Kolorowa sałatka z kokosowym sosem coattail',
prev: 'salat_mit_kokos_coacktailsauce.jpg',
time: '10 min.',
ingredients:
 [ '½ sałaty lodowej',
   '2 pomidory',
   ', 30 g szynki',
   ', ½ ogórka',
   '2 jajka na twardo',
   '200 ml mleka kokosowego',
   '1 łyżka pasty pomidorowej',
   ', 1/2 łyżeczki musztardy',
   ', Sól, pieprz, curry, papryka w proszku' ],
preparation:
 [ 'Umyć warzywa, obrać i pokroić na małe kawałki. Obierz małe jajka. Pokroić szynkę w paski. Umieść wszystkie składniki w misce.',
   'Dobrze wymieszaj pastę pomidorową, mleko kokosowe i musztardę. Sezon zgodnie z życzeniem.',
   'Nadaj sałatce sos.' ],
portions: 1,
tags: [ 'Exotisch', 'Dinner', 'Snacks' ] },
{ name: 'Sałatka z fasoli tuńczyka',
prev: 'thunfisch_bohnen.jpg',
time: '10 min.',
ingredients:
 [ '½ puszki tuńczyka we własnym soku',
   ', 3 pomidory koktajlowe',
   ', 80 gramów fasoli',
   '1 cebula',
   ', 50 gramów kukurydzy',
   ', ¼ pęczek pietruszki',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Pomyj pomidory i pokrój małe. Cebulę obrać, drobno posiekać. Opróżnij fasolę i kukurydzę. Umyć natkę pietruszki, drobno posiekać.',
   'Dawanie warzyw w misce. Daj oliwę z oliwek. Dopraw solą i pieprzem.' ],
portions: 1,
tags: [ 'Proteinreich', 'Dinner', 'Snacks' ] },
{ name: 'Protein Power Salad',
prev: 'protein_power.jpg',
time: '25 min.',
ingredients:
 [ '2 jajka',
   '1 kawałek fileta z kurczaka',
   '1 cebula wiosenna',
   '1 łyżka nasion słonecznika',
   '1 pomidor',
   ', ½ ogórka',
   '1 łyżka stołowa jogurtu naturalnego',
   '1 łyżka octu',
   '2 łyżki oliwy z oliwek',
   '1/2 łyżeczki musztardy',
   ', Sól, pieprz' ],
preparation:
 [ 'Pomyj pomidor, szczypiorkę, ogórek i drobno posiekaj. Filet z kurczaka pokroić w paski. Podgrzej wodę na patelni i gotuj jajka przez 10 minut. Obierz jajka i pokrój na małe kawałki. Umieść wszystkie składniki w misce.',
   'Podgrzej oliwę na patelni. Smażone paski kurczaka. Dopraw solą i pieprzem. Dodaj paski kurczaka do miski.',
   'Wymieszaj jogurt, ocet, 1 łyżkę oliwy z oliwek i musztardę. Dopraw solą i pieprzem, dodaj do sałatki. W razie potrzeby posyp sałatką nasiona słonecznika.' ],
portions: 1,
tags: [ 'Mit Hähnchenfilet', 'Dinner', 'Snacks' ] },
{ name: 'Sałatka ze stekiem z awokado',
prev: 'avocado_steak.jpg',
time: '30 min.',
ingredients:
 [ '1 stek wołowy',
   '2 łyżki oliwy z oliwek',
   ', 4 pomidory koktajlowe',
   ', ½ cebuli',
   ', ¼ szef sałaty lodowej',
   ', ½ ogórka',
   ', ½ awokado',
   '1 łyżeczka miodu',
   '1 łyżka soku z cytryny',
   ', Sól, pieprz, proszek chili' ],
preparation:
 [ 'Podgrzej oliwę na patelni. Dopraw stek solą i pieprzem i smaż na średnim ogniu przez 4-6 minut z każdej strony.',
   'Wymieszaj sok z cytryny z miodem i 1 łyżką oliwy z oliwek w małej misce. Doprawiamy chili w proszku i pieprzem.',
   'Umyj warzywa. Pokroić sałatkę na kawałki wielkości kęsa. Obierz awokado, usuń nasiona i pokrój na drobne kawałki. Pomidory czereśniowe o połówce. Pokrój cebulę i ogórek w cienkie plasterki. Pokroić stek na kawałki wielkości kęsa. Umieść wszystkie składniki w misce i polej dressingiem.' ],
portions: 1,
tags: [ 'Für Feinschmecker', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Sałatka z jajkiem Tofu z quinoą',
prev: 'tofu_ei_salat_mit_quinoa.jpg',
time: '15 min.',
ingredients:
 [ '100 g tofu',
   ', 50 g komosy ryżowej (surowej)',
   '1 jajko',
   '2 słupki dymki',
   '1 pomidor',
   ', ½ pieprzu',
   '1 łyżka oliwy z oliwek',
   '2 łyżki soku z cytryny',
   '1 kij pietruszki',
   ', pieprz' ],
preparation:
 [ 'Gotuj quinoa w osolonej wodzie przez 10 minut. Gotuj jajko przez około 10 minut.',
   'Rzuć tofu. Pomidory i paprykę umyć na małe kawałki. Cebulę umyć, pokroić w cienkie pierścienie. Umyć natkę pietruszki, drobno posiekać.',
   'Wymieszać oliwę z sokiem z cytryny. Dopraw pieprzem. Ugotuj jajko na twardo.',
   'Wymieszaj komosę z warzywami i jajkiem w misce. Przekaż opatrunek i podaj.' ],
portions: 1,
tags: [ 'Proteinreich', 'Dinner', 'Snacks' ] },
{ name: 'Jajko sadzone z zieloną fasolką i boczkiem',
prev: 'spiegelei_bohnen.jpg',
time: '15 min.',
ingredients:
 [ '1-2 jajka',
   '200 g zielonej fasoli',
   ', 50 g boczku lub szynki',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyć zieloną fasolkę i odciąć końce. Ogrzej garnek soloną wodą i gotuj fasolę na średnim ogniu przez 10 minut. Pokrój bekon na małe kawałki.',
   'Podgrzej oliwę na patelni. Podsmażyć kawałki bekonu i wyjąć je. Następnie umieść jajko na patelni. Dopraw solą i pieprzem i dodaj do smażonego jajka.',
   'Podawać fasolkę szparagową, bekon i jajka sadzone na talerzu. W razie potrzeby dopraw solą i pieprzem.' ],
portions: 1,
tags: [ 'Deftig', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Bufet z cukinii z marchwi',
prev: 'karotten_zucchini_puffer.jpg',
time: '20 min.',
ingredients:
 [ '150 g marchwi',
   ', ½ cukinii',
   ', ½ łyżki soku z cytryny',
   '1 łyżka pietruszki',
   '1 jajko',
   ', 4 łyżki płatków owsianych',
   '2 łyżki niskotłuszczowego kwarka ziołowego',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyć marchew i cukinię, obrać i drobno zetrzeć na tarce do warzyw.',
   'Zmieszaj starte warzywa z sokiem z cytryny, posiekaną natką pietruszki, jajkiem i płatkami owsianymi. Dopraw solą i pieprzem.',
   'Podgrzej oliwę na patelni. Za pomocą łyżeczki wystawiaj małe porcje i umieść na rozgrzanej patelni. Lekko wycisnąć ciasto i podsmażyć bufory z obu stron na średnim ogniu.',
   'Ułóż bufory warzywne z kwarkiem ziołowym na talerzu.' ],
portions: 1,
tags: [ 'Low Carb', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Sałatka z fasoli bazylii',
prev: 'basilikum_bohnen.jpg',
time: '15 min.',
ingredients:
 [ '200 g zielonej fasoli',
   '1 łyżeczka orzeszków piniowych',
   ', ¼ pęczek bazylii',
   ', ½ ząbka czosnku',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyć zieloną fasolkę, odciąć końce i gotować w osolonej wodzie przez 10 minut.',
   'Umyj bazylię, obierz liście i drobno posiekaj. Obierz czosnek goździkowy, naciśnij.',
   'Czosnek, bazylia z oliwą z oliwek. Polać ugotowaną fasolą, a następnie posypać orzeszkami pinii.' ],
portions: 1,
tags: [ 'Gut vorzubereiten', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'szpinak smażony',
prev: 'spinat_spiegelei.jpg',
time: '15 min.',
ingredients:
 [ '3 jajka',
   ', 3 łyżki jogurtu o niskiej zawartości tłuszczu',
   '150 g szpinaku (mrożone lub świeże)',
   '1 łyżeczka oliwy z oliwek',
   ', Papryka, chili w proszku, sól, pieprz' ],
preparation:
 [ 'Podgrzej oliwę na patelni. Umieść szpinak na patelni. Podsmażyć krótko. Wepchnij szpinak na patelnię z boku.',
   'Otwórz jajka na patelni i uzupełnij. Dopraw solą i pieprzem.',
   'Wymieszaj chili w proszku z jogurtem. Następnie dopraw solą, pieprzem i papryką. Podawać z jajkami i szpinakiem.' ],
portions: 1,
tags: [ 'Voller Mineralstoffe', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'berry muesli',
prev: 'beerenmuesli.png',
time: '10 min.',
ingredients:
 [ '50 g płatków owsianych',
   ', 30 g migdałów',
   '150 g jagód (świeżych lub mrożonych)',
   '250 g niskotłuszczowego twarogu',
   '150 ml niskotłuszczowego mleka' ],
preparation:
 [ 'Smażyć migdały na patelni na średnim ogniu przez około 4 minuty. Następnie drobno posiekaj. Umyj jagody.',
   'Wymieszać ze sobą płatki owsiane, posiekane migdały, świeże (lub rozmrożone jagody), mleko i odtłuszczony twaróg.' ],
portions: 1,
tags: [ 'Nährstoffreich', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Jajecznica śródziemnomorska',
prev: 'mediteranes_ruehrei.png',
time: '15 min.',
ingredients:
 [ '3 jajka',
   ', 4 pomidory koktajlowe',
   '20 g rakiety',
   '100 g niskotłuszczowej fety',
   '1 łyżka oliwy z oliwek',
   ', pieprz' ],
preparation:
 [ 'Umyj pomidory i rukolę. Rozwałkuj pomidory i drobno posiekaj rakietę. Pokrój ser feta w małe kostki.',
   'Umieść jajka i rukolę w misce, ubij i przypraw pieprz.',
   'Podgrzej oliwę na patelni. Dodaj pomidory do patelni i krótko podsmaż. Wlej jajka na patelnię i uzupełnij. Dopraw pieprzem.',
   'Podawaj jajecznicę na talerzu i posyp fetą.' ],
portions: 1,
tags: [ 'Proteinreich', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Granola orzechowa jabłkowa',
prev: 'nuss_apfel_muesli.jpg',
time: '5 min.',
ingredients:
 [ '1 jabłko',
   ', 30 gramów orzechów włoskich',
   ', 50 g płatków owsianych',
   '200 g chudego kwarka',
   '150 ml niskotłuszczowego mleka',
   'cynamon' ],
preparation:
 [ 'Umyć jabłko, pokroić na małe kawałki. Chop nuts.',
   'Mieszać płatki owsiane, kawałki jabłek, orzechy włoskie z chudym twarogiem i mlekiem. Posypać cynamonem płatki.' ],
portions: 1,
tags: [ 'Sättigend', 'Breakfast', 'Snacks' ] },
{ name: 'Boczek i jajka',
prev: 'bacon_eggs.png',
time: '10 min.',
ingredients:
 [ '3 jajka',
   ', 4 paski słoniny o niskiej zawartości tłuszczu',
   '1 łyżka oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Podgrzej oliwę na patelni. Smażone paski boczku, zdejmij i ogrzej.',
   'Wlej jajka na patelnię i dodaj jajka sadzone. Dopraw solą i pieprzem.' ],
portions: 1,
tags: [ 'Deftig', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'Koktajl z mięty ogórka',
prev: 'minz_gurke.jpg',
time: '5 min.',
ingredients:
 [ '250 g niskotłuszczowego twarogu',
   '1 garść świeżej mięty',
   ', ½ ogórka',
   ', ½ cytryny',
   '200 ml wody' ],
preparation:
 [ 'Umyj ogórek i liście mięty. Pokrój ogórek na małe kawałki. Wyciśnij cytrynę.',
   'Umieścić wszystkie składniki w wysokim pojemniku i dokładnie puree blenderem.' ],
portions: 1,
tags: [ 'Erfrischend', 'Dinner', 'Drink' ] },
{ name: 'Koktajl z ogórka brzoskwiniowego',
prev: 'pfirsich_gurke.jpg',
time: '10 min.',
ingredients:
 [ '2 brzoskwinie',
   ', ¼ ogórek',
   ', 50 ml wody',
   '200 g jogurtu naturalnego',
   '1 łyżeczka miodu' ],
preparation:
 [ 'Umyć brzoskwinie i ogórek pokroić na małe kawałki.',
   'Włóż jogurt naturalny i wodę wraz z kawałkami brzoskwini i ogórka do wysokiego pojemnika. Purée z blenderem ręcznym. Słuchaj miodem według własnego uznania.',
   'Podawać na zimno.' ],
portions: 1,
tags: [ 'Einfach', 'Dinner', 'Drink' ] },
{ name: 'Mrożona herbata z imbirem',
prev: 'limetten_ingwer.jpg',
time: '15 min.',
ingredients:
 [ '4 torby zielonej herbaty',
   '2 limonki',
   ', 35 g świeżego imbiru',
   ', 500 ml wody',
   '2 łyżeczki miodu',
   'kostki lodu' ],
preparation:
 [ 'Umyć imbir, obrać i pokroić w cienkie plasterki. Umyć limonki, pokroić w cienkie plasterki.',
   'Zagotuj wodę w czajniku. Włóż do dużego pojemnika. Dodaj plasterki imbiru i limonki i odstaw na około 5 minut.',
   'Dodaj torebkę i odstaw na kolejne 5 minut. Wyjmij torebkę herbaty i osłodz ją 2 łyżeczkami miodu. Poczekaj, aż herbata ostygnie.',
   'Podawać na zimno z kostkami lodu.' ],
portions: 4,
tags: [ 'Aromatisch', 'Drink' ] },
{ name: 'Mrożona herbata cytrynowa',
prev: 'zitronen_eistee.jpg',
time: '15 min.',
ingredients:
 [ '4 torby czarnej herbaty',
   '1 pomarańczowy',
   '1 cytryna',
   ', 500 ml wody',
   'kostki lodu' ],
preparation:
 [ 'Umyć pomarańczę i cytrynę i pokroić w cienkie plasterki.',
   'Zagotuj wodę w czajniku i umieść w dużym pojemniku. Dodaj torebkę i pozostaw na 5 minut. Wyjmij torbę.',
   'Włóż plasterki cytryny i pomarańczy do ciepłej herbaty. Poczekaj, aż ostygnie i odstaw się.',
   'Podawać z jajkami w szklance.' ],
portions: 4,
tags: [ 'Erfrischend', 'Drink' ] },
{ name: 'Herbata lodowa z cytryną',
prev: 'zitronen_blaubeer.jpg',
time: '15 min.',
ingredients:
 [ '4 torby zielonej herbaty',
   '200 g jagód',
   '1 cytryna',
   ', 500 ml wody',
   'kostki lodu' ],
preparation:
 [ 'Umyć cytrynę i jagody. Pokrój cytrynę w cienkie plasterki.',
   'Zagotuj wodę w czajniku i umieść w dużym pojemniku. Dodaj torebkę i odstaw na około 5 minut. Następnie wyjmij torebkę ponownie.',
   'Do herbaty dodaj plasterki cytryny i jagody. Schłodzić herbatę w lodówce i pozostawić do namoczenia.',
   'Podawać z jajkami w szklance.' ],
portions: 4,
tags: [ 'Aromatisch', 'Drink' ] },
{ name: 'Ananasowy koktajl pomarańczowy',
prev: 'ananas_orange.jpg',
time: '5 min.',
ingredients:
 [ '150 g ananasa (3-4 pierścienie ananasa)',
   '1 pomarańczowy',
   '100 g szpinaku',
   '250 ml wody' ],
preparation:
 [ 'Umyj szpinak i pomarańczę. Obierz pomarańczę, pokrój w małe kawałki. Pokrój ananasa na małe kawałki.',
   'Włóż wodę, owoce i warzywa do wysokiego pojemnika. Purée z blenderem.' ],
portions: 1,
tags: [ 'Exotisch', 'Drink', 'Vegan' ] },
{ name: 'Koktajl Berry Power',
prev: 'beeren_power.jpg',
time: '5 min.',
ingredients:
 [ '250g jagód (na przykład truskawki)',
   ', ½ mango',
   '250 ml wody',
   '100 g szpinaku' ],
preparation:
 [ 'Umyj jagody, szpinak i mango. Obierz mango, pokroić na małe kawałki.',
   'Włóż wodę, owoce i warzywa do wysokiego pojemnika. Purée z blenderem.' ],
portions: 1,
tags: [ 'Vitaminbombe', 'Drink', 'Vegan' ] },
{ name: 'Koktajl bananowy z gruszkami',
prev: 'birnen_bananen.jpg',
time: '5 min.',
ingredients: [ '2 gruszki', '1 banan', '100 g szpinaku', '250 ml wody' ],
preparation:
 [ 'Umyj gruszki i szpinak. Obierz banana. Pokrój owoce na małe kawałki.',
   'Włóż wodę, owoce i warzywa do wysokiego pojemnika. Purée z blenderem.' ],
portions: 1,
tags: [ 'Fruchtig', 'Drink', 'Vegan' ] },
{ name: 'Koktajl z jabłek pietruszki',
prev: 'petersilie_apfel.jpg',
time: '5 min.',
ingredients: [ '3 jabłka', '150 g pietruszki', '10 g imbiru' ],
preparation:
 [ 'Umyć imbir, obrać, drobno posiekać. Umyć jabłka i natkę pietruszki. Pokrój jabłka na małe kawałki.',
   'Umieść wszystkie składniki w wysokim pojemniku. Purée z blenderem.' ],
portions: 1,
tags: [ 'Originelle Idee', 'Drink', 'Vegan' ] },
{ name: 'Shake bananowy',
prev: 'bananen_shake.jpg',
time: '10 min.',
ingredients:
 [ '1 banan',
   '200 g chudego kwarka',
   '1 łyżeczka miodu',
   ', 400 ml wody' ],
preparation:
 [ 'Obrać banana, pokroić na małe kawałki.',
   'Umieść miód, odtłuszczony twaróg i wodę w wysokim pojemniku i puree z blenderem.' ],
portions: 1,
tags: [ 'Der Klassiker', 'Snacks', 'Drink' ] },
{ name: 'Koktajl z jagód miodowych',
prev: 'honig_beeren.jpg',
time: '5 min.',
ingredients:
 [ '250 g niskotłuszczowego twarogu',
   '200 g mrożonych jagód (np. Jagód)',
   '200 ml wody',
   '1 łyżeczka miodu' ],
preparation:
 [ 'Umieść wszystkie składniki w wysokim pojemniku i dokładnie puree.',
   'Jeśli wybierzesz świeże jagody, dodaj trochę pokruszonego lodu.' ],
portions: 1,
tags: [ 'Fruchtig', 'Snacks', 'Drink' ] },
{ name: 'Koktajl kiwi',
prev: 'apfel_kiwi_smoothie.jpg',
time: '5 min.',
ingredients:
 [ '1 jabłko',
   '1 dojrzałe kiwi',
   ', 4 łyżki jogurtu naturalnego',
   ', 3 łyżki twarogu',
   '2-3 kostki lodu',
   '250 ml niegazowanej wody' ],
preparation:
 [ 'Obierz jabłko i kiwi. Zasadź jabłko. Wytnij owoce.',
   'Umieść wszystkie składniki w wysokim pojemniku. Purée z blenderem.' ],
portions: 1,
tags: [ 'Superschnell', 'Snacks', 'Drink' ] },
{ name: 'Peach banana shake',
prev: 'pfirsich_bananen.jpg',
time: '10 min.',
ingredients:
 [ '1 dojrzała brzoskwinia',
   '1 dojrzały banan',
   '1 łyżeczka miodu',
   ', 5 łyżek niskotłuszczowego twarogu',
   ', 300 ml zimnej wody' ],
preparation:
 [ 'Umyć brzoskwinię. Obierz banana i brzoskwinie. Pokrój owoce na drobne kawałki.',
   'Umieść wszystkie składniki w wysokim pojemniku i wymieszaj ręcznie mikserem.' ],
portions: 1,
tags: [ 'Vitaminbombe', 'Snacks', 'Drink' ] },
{ name: 'Kiwi Cytryny Shake',
prev: 'kiwi_zitronen_shake.jpg',
time: '10 min.',
ingredients:
 [ '2 kiwi',
   ', 3 plasterki ananasa',
   ', ½ cytryny',
   '1 łyżeczka miodu',
   '150 g niskotłuszczowego twarogu',
   '2 łyżeczki kruszonych lodów' ],
preparation:
 [ 'Obierz kiwi, pokroić na małe kawałki. Pokrój plasterki ananasa na małe kawałki. Wyciśnij cytrynę.',
   'Wymieszaj sok z cytryny z miodem.',
   'Umieść wszystkie składniki w wysokim pojemniku i puree.' ],
portions: 1,
tags: [ 'Vitaminbombe', 'Snacks', 'Drink' ] },
{ name: 'Czekoladowy koktajl kokosowy',
prev: 'schoko_kokos.jpg',
time: '10 min.',
ingredients:
 [ '100 ml mleka kokosowego',
   '1 łyżeczka proszku kakaowego (niesłodzone)',
   '100 ml niskotłuszczowego mleka',
   '1 łyżka kruszonego lodu',
   '1 łyżeczka startego kokosa' ],
preparation:
 [ 'Umieść proszek kakaowy z mlekiem kokosowym, mlekiem i lodem w szczelnym pojemniku (np. Shaker). Potrząśnij energicznie.',
   'W razie potrzeby posypać płatkami kokosowymi.' ],
portions: 1,
tags: [ 'Fruchtig-süß', 'Snacks', 'Drink' ] },
{ name: 'Power Booster Shake',
prev: 'starter_shake.png',
time: '5 min.',
ingredients:
 [ '40 g płatków owsianych',
   '20 g wystrzelonego amarantusa',
   '100 g jagód np. jagody',
   ', 400 ml płatków owsianych',
   '1 łyżka siemię lniane',
   ', 30 gramów orzechów włoskich',
   '1 łyżka syropu z agawy',
   ', 4 kostki lodu',
   '1 łyżeczka proszku matcha' ],
preparation:
 [ 'Posiekaj orzechy włoskie.',
   'Umieść wszystkie składniki w mikserze i wymieszaj.' ],
portions: 1,
tags: [ 'Superschnell', 'Breakfast', 'Snacks', 'Vegan' ] },
{ name: 'Chrupiące naleśniki z kremem malinowym',
prev: 'pancake.jpg',
time: '20 min.',
ingredients:
 [ '60 g mąki razowej',
   '10 g syropu z agawy',
   '140 ml mleka sojowego',
   '1 łyżka oliwy z oliwek',
   '1 łyżeczka proszku do pieczenia',
   ', 30 g wystrzelonego amarantusa',
   '150 g malin (mrożone)',
   ', 30 g syropu z agawy',
   '100 g jogurtu sojowego' ],
preparation:
 [ 'Zmieszaj mąkę razową, 10 g syropu z agawy, mleko sojowe, proszek do pieczenia i trochę soli w cieście ze zjeżdżalnią. Następnie złóż amarantusa.',
   'Podgrzej oliwę na patelni. Dodaj jedną łyżkę ciasta na patelnię i stopniowo przygotuj około 6 małych naleśników. Smażyć przez około 4 minuty po obu stronach na średnim ogniu.',
   'Umieść maliny, 30g syrop z agawy i jogurt sojowy w blenderze i dokładnie puree.',
   'Podawać śmietanę malinową z naleśnikami.' ],
portions: 2,
tags:
 [ 'Ballaststoffreiche Alternative',
   'Breakfast',
   'Snacks',
   'Vegan' ] },
{ name: 'Kokosowa Żurawina Musli',
prev: 'cranberry_kokos.jpg',
time: '10 min.',
ingredients:
 [ '100 g płatków owsianych',
   ', 50 g mleka kokosowego',
   ', 30 g syropu z agawy',
   ', 40 gramów żurawiny',
   '160 g jogurtu sojowego',
   '2 kromki ananasa',
   ', 30 g startego kokosa' ],
preparation:
 [ 'W misce wymieszaj płatki owsiane z mlekiem kokosowym, syropem z agawy, żurawiną i jogurtem sojowym. Pozwól mu odpocząć przez 4 minuty.',
   'Pokrój plasterki ananasa na małe kawałki.',
   'Wymieszaj kawałki ananasa i startego kokosa z pozostałym muesli.' ],
portions: 1,
tags: [ 'Nährstoffreich', 'Breakfast', 'Snacks', 'Vegan' ] },
{ name: 'Süßkartoffelsalat',
prev: 'suesskartoffelsalat.jpg',
time: '30 min.',
ingredients:
 [ '1 duży słodki ziemniak',
   '100 g kiełków mieszanych (np. Kiełki rzodkiewki)',
   '1/2 cytryny',
   '2 łyżki białego octu winnego',
   '1/2 łyżeczki gorącej musztardy',
   '1 łyżeczka chrzanu',
   ', 3 łyżki oliwy z oliwek',
   '1/2 grona kolendry',
   '2 słupki dymki',
   ', Sól, pieprz',
   '& Nbsp;' ],
preparation:
 [ 'Umyć słodki ziemniak i gotować w osolonej wodzie do miękkości. Wlać, obrać i pokroić na małe kawałki.',
   'W międzyczasie umyć kiełki. Umyć i wycisnąć cytrynę. Wymieszaj sok z cytryny z octem, musztardą, chrzanem, solą i pieprzem. Stopniowo mieszać oliwę z oliwek.',
   'Umyj kolendrę, osusz, oderwij liście. Umyć dymkę i pokroić w cienkie pierścienie.',
   'Włóż do miski słodkie kawałki ziemniaków, kolendrę, dymkę i kiełki. Dopraw solą i pieprzem. Nadaj marynacie sałatkę i podawaj.' ],
portions: 2,
tags: [ 'Sättigend', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Zupa z buraków z chrzanem',
prev: 'rote_beete_suppe.jpg',
time: '30 min.',
ingredients:
 [ '1 cebula',
   '1 słodki ziemniak',
   ', 400 g czerwonych łóżek',
   '1 łyżka oliwy z oliwek',
   ', 800 ml solonej wody (lub bulionu warzywnego)',
   '1 łyżka białego octu winnego',
   ', mielony kminek',
   '1 łyżka chrzanu',
   '100 ml śmietany sojowej',
   ', Sól, pieprz' ],
preparation:
 [ 'Obierz cebulę i posiekaj ją na drobne kawałki. Umyć ziemniaki i buraki, obrać i pokroić w drobne kawałki.',
   'Podgrzej oliwę na patelni. Na krótko podsmaż cebulę. Dodaj ziemniaki i buraki i smaż przez krótki czas. Deglaze solona woda. Dopraw solą, pieprzem, octem i kminkiem. Przykryj i gotuj przez 20 minut.',
   'Dodaj chrzan, a następnie purée zupy ze stemplem. Wymieszać w 100 ml śmietany sojowej.' ],
portions: 2,
tags: [ 'Nährstoffreich', 'Lunch', 'Dinner', 'Vegan' ] },
{ name: 'Jajecznica z tofu',
prev: 'tofu_ruehrei.png',
time: '15 min.',
ingredients:
 [ '200 g miękkiego naturalnego tofu',
   '1 łyżka oliwy z oliwek',
   '1 łyżka wody',
   '2 pomidory cherry',
   '1 kij szczypiorku',
   'Kurkuma 1/2 Tl',
   ', Sól, pieprz' ],
preparation:
 [ 'Zgnieść tofu widelcem. Pomidory, mycie wiosennej cebuli. Połówki pomidorów. Cebulę pokroić w cienkie pierścienie.',
   'Podsmaż tofu przez około 3 minuty. Dodaj pomidory i szczypiorki i krótko podsmaż. Dopraw kurkumą, solą i pieprzem.' ],
portions: 1,
tags:
 [ 'Vegane Alternative', 'Breakfast', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Chrupiące musli migdałowe',
prev: 'mandelmuesli.png',
time: '10 min.',
ingredients:
 [ 'Wystrzelił 20 g amarantusa',
   '25 g płatków kukurydzianych (niesłodzonych)',
   ', 40 gramów płatków owsianych',
   '15 g prażonych migdałów',
   '20 g jagód',
   '15 g migdałów',
   '20 gramów żurawiny',
   '1 łyżka siemię lniane',
   ', Wasze owoce, np. 1 banan',
   '200 ml mleka migdałowego' ],
preparation:
 [ 'W misce wymieszaj amarant, płatki kukurydziane, płatki owsiane, prażone migdały i migdały.',
   'Umyj jagody. Obierz banana i pokrój na kawałki wielkości kęsa. Dodaj owoce do miski i wymieszaj z innymi składnikami.',
   'Wlać chrupiącą granolę z mlekiem migdałowym.' ],
portions: 1,
tags: [ 'Mit Amaranth', 'Breakfast', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Klopsiki z puree ze słodkich ziemniaków',
prev: 'frikadellen_mit_suesskartoffel.jpg',
time: '30 min.',
ingredients:
 [ '400 g marchwi',
   '1 słodki ziemniak',
   ', 300 g mielonego mięsa wołowego o niskiej zawartości tłuszczu',
   '2 łyżki twarogu',
   '2 łyżeczki razowej bułki tartej',
   '1 łyżka oliwy z oliwek',
   ', 3 łyżki posiekanych ziół',
   ', 3-4 łyżki mleka o niskiej zawartości tłuszczu',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyć marchew i słodkie ziemniaki, obrać i pokroić na małe kawałki. Włóż na patelnię wypełnioną słoną wodą i gotuj przez około 15 minut.',
   'W międzyczasie zagnieść klops, chudego twarogu, razową bułkę tartą, zioła, sól i pieprz razem. Zrób z niego 4 klopsiki.',
   'Podgrzej oliwę na patelni. Brązowe klopsiki na średnim ogniu.',
   'Odcedź marchewki i ziemniaki. Dodać mleko o niskiej zawartości tłuszczu i drobno zmiażdżone. Dopraw solą i pieprzem. Podawać z klopsikami.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch' ] },
{ name: 'Wieża buraczana z kremem z awokado',
prev: 'rote_beete_tower.jpg',
time: '20 min.',
ingredients:
 [ '250 g czerwonych buraków',
   ', 300 g naturalnego tofu',
   ', 3 łyżki oliwy z oliwek',
   '2 łyżeczki syropu z agawy',
   '1 ząbek czosnku',
   ', 3 awokado',
   '1 łyżka soku z cytryny',
   ', trochę rukwi wodnej',
   ', Sól, pieprz' ],
preparation:
 [ 'Buraki umyć, pokroić w cienkie plasterki. Podgrzej garnek soloną wodą i gotuj przez około 10 minut, aż stanie się miękka.',
   'Tofu pokroić w plastry o grubości 5 mm, a następnie wyciąć niewielką szklanką kół czerwonych buraków.',
   'Podgrzej oliwę na patelni i podsmaż tofu przez około 3 minuty z każdej strony. Dopraw solą i pieprzem.',
   'Obierz czosnek, drobno posiekaj. Umyć, przekroić awokado i przekroić. Puree z awokado z czosnkiem i sokiem z cytryny. Dopraw solą i pieprzem.',
   'Warstwuj plasterki tofu na przemian z kremem z buraków i awokado. Posypać rzeżuchą i podawać.' ],
portions: 2,
tags: [ 'Originelle Idee', 'Lunch', 'Dinner', 'Snacks', 'Vegan' ] },
{ name: 'Ravioli z kalarepy z sosem z bazylii pomidorowej',
prev: 'kohlrabi_ravioli.jpg',
time: '30 min.',
ingredients:
 [ '2 kalarepa',
   ', 6 łyżek oliwy z oliwek',
   '1 czerwona papryka',
   '1 1/2 cebuli',
   '2 pomidory',
   '1/2 pęczka bazylii',
   '2 ząbki czosnku',
   ', Sól, pieprz, oregano' ],
preparation:
 [ 'Kalarepę umyć, obrać i pokroić lub pokroić w bardzo cienkie plasterki. Zagotuj osoloną wodę w rondlu, zdejmij z ognia i pozwól delikatnemu gulaszowi z mątwy na około 10 minut. Opróżnij dobrze papierowym ręcznikiem. Wymieszaj 2 łyżki oliwy z oliwek i 1 szczyptę soli w małej misce, dodaj plastry kalarepy i marynuj.',
   'Umyj papryki, usuń nasiona i pokrój na drobne kawałki. Obierz cebulę, drobno posiekaj. Podgrzej 1 łyżkę oliwy z oliwek na patelni i podsmaż około 1/3 kawałków cebuli i papryki przez około 5 minut. Wyjąć patelnię z ognia i rozgnieść smażoną mieszankę pomidorów i cebuli widelcem. Doprawić oregano, solą i pieprzem. Umieść patelnię z powrotem na kuchence i podgrzej na krótko, aż mieszanina stanie się kremowa.',
   'Na środku marynowanych plasterków kalarepy dodaj 1 łyżeczkę masy paprykowo-cebulowej. Połóż drugi plasterek kalarepy na górze i naciśnij coś na boku.',
   'Pomyj pomidory i kostki małe. Obrać ząbki czosnku, drobno posiekać, rozgrzać oliwę na patelni. Duszymy pozostałą cebulę i czosnek przez około 2 minuty. Dodaj pomidory i krótko gotuj. Złożyć bazylię. Dopraw solą i pieprzem.' ],
portions: 2,
tags: [ 'Gesunde Alternative', 'Lunch', 'Dinner', 'Vegan' ] },
{ name: 'Czekoladowe lody orzechowe',
prev: 'schoko_erdnuss_eis.jpg',
time: '25 min.',
ingredients:
 [ '200 g orzeszków ziemnych',
   '250 g kostek lodu',
   ', 65 g syropu agawowego',
   '1/2 łyżeczki zmielonej wanilii',
   ', sól',
   ', 40 g kakao' ],
preparation:
 [ 'W blenderze wymieszaj orzeszki ziemne, syrop z agawy, kostki lodu, sól i wanilię.',
   'Wymieszać połowę mieszanki z kakao. Wymieszaj obie masy ponownie widelcem.',
   'Zimny lód w misce w lodówce przez około 20 minut.' ],
portions: 1,
tags: [ 'Erfrischend', 'Snacks', 'Vegan' ] },
{ name: 'Jajka w sosie musztardowym',
prev: 'eier_senf.jpg',
time: '25 min.',
ingredients:
 [ '4 jajka',
   '1 mała cebula',
   ', 50 ml mleka niskotłuszczowego',
   '2 łyżeczki koperku',
   '2 łyżki twarogu',
   '2 łyżki jogurtu o niskiej zawartości tłuszczu',
   ', 3 łyżeczki musztardy',
   '1 łyżeczka oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Gotuj jajka przez około 10 minut.',
   'Cebulę obrać, drobno posiekać.',
   'Podgrzej oliwę na patelni. Podsmażyć kostki cebuli, aż będą szkliste.',
   'Deglaze z mlekiem. Wymieszać z twarogiem, jogurtem i musztardą. Doprowadzić do wrzenia.',
   'Jajka na twardo obrać, przekroić na pół i podawać z sosem.' ],
portions: 1,
tags: [ 'Proteinreich', 'Breakfast', 'Dinner', 'Snacks' ] },
{ name: 'zupa pietruszka',
prev: 'petersiliensuppe.jpg',
time: '30 min.',
ingredients:
 [ 'Korzeń pietruszki 200g',
   ', ½ czerwonej cebuli',
   '1 ząbek czosnku',
   '200g twarogu',
   ', ½ kiści pietruszki',
   '250 ml wody',
   '1 l oliwy z oliwek',
   ', Sól, pieprz' ],
preparation:
 [ 'Umyć korzeń pietruszki, pokroić na pół i pokroić w plasterki.',
   'Cebulę i czosnek obrać, drobno pokroić w kostkę.',
   'Podgrzej oliwę w rondlu. Włóż kostkę pietruszki, cebulę i czosnek na patelnię i smaż przez około 5 minut.',
   'Dodaj wodę i gotuj na wolnym ogniu przez około 20 minut.',
   'W międzyczasie umyć natkę pietruszki, osuszyć i drobno posiekać. Po zakończeniu czasu gotowania zupę miksuj ręcznie. Dodać twaróg i posypać natką pietruszki.' ],
portions: 1,
tags: [ 'Aromatisch', 'Lunch', 'Dinner', 'Snacks' ] },
{ name: 'Marchewkowy ogórek smoothie',
prev: 'moere_gurken_smothie.jpg',
time: '5 min.',
ingredients:
 [ '1 ogórek',
   ', 300 ml soku z marchwi (niesłodzone)',
   ', 50 g płatków owsianych',
   '200g twarogu',
   '100 ml wody' ],
preparation:
 [ 'Umyć ogórek, z grubsza pokroić na kawałki.',
   'Wymieszaj wszystkie składniki w blenderze i drobno puree, aż powstanie kremowy shake.' ],
portions: 1,
tags: [ 'Mahlzeitersatz', 'Drink' ] }
]


// WEBPACK FOOTER //
// ./src/store/fitnes/modules/recipts/pl.js